import { NavItem, Feature, Testimonial, PricingPlan, FooterLink } from '../types';

export const navigationItems: NavItem[] = [
  { label: 'Início', href: '#home' },
  { label: 'Soluções', href: '#features' },
  { label: 'Preços', href: '#pricing' },
  { label: 'FAQ', href: '#faq' },
];

export const features: Feature[] = [
  {
    id: '1',
    title: 'Business Intelligence',
    description: 'Transforme dados em insights acionáveis com dashboards interativos e relatórios personalizados.',
    icon: 'BarChart3',
  },
  {
    id: '2',
    title: 'Analytics Avançado',
    description: 'Análise preditiva e descritiva para tomada de decisões estratégicas baseadas em dados.',
    icon: 'TrendingUp',
  },
  {
    id: '3',
    title: 'Integração de Dados',
    description: 'Conecte múltiplas fontes de dados em uma única plataforma unificada.',
    icon: 'Database',
  },
  {
    id: '4',
    title: 'Automação de Relatórios',
    description: 'Gere relatórios automáticos e distribua insights em tempo real para sua equipe.',
    icon: 'FileText',
  },
  {
    id: '5',
    title: 'Consultoria Especializada',
    description: 'Equipe de especialistas em BI para implementação e otimização de soluções.',
    icon: 'Users',
  },
  {
    id: '6',
    title: 'Escalabilidade Corporativa',
    description: 'Soluções que crescem com sua empresa, desde startups até grandes corporações.',
    icon: 'Building',
  },
];

// Funcionalidades específicas do Mercado Livre
export const mercadolivreFeatures = [
  {
    id: '1',
    title: 'Curva ABC',
    description: 'Classifique seus produtos por performance e rentabilidade. Identifique quais itens geram mais receita e otimize seu mix de produtos para maximizar lucros.',
    icon: 'BarChart3',
    benefits: [
      'Identificação automática dos produtos mais lucrativos',
      'Análise de rentabilidade por categoria',
      'Recomendações para otimização do mix',
      'Relatórios semanais e mensais'
    ]
  },
  {
    id: '2',
    title: 'Gestão de Promoções',
    description: 'Monitore e otimize suas campanhas promocionais em tempo real. Acompanhe o impacto das promoções na performance de vendas e ROI.',
    icon: 'TrendingUp',
    benefits: [
      'Acompanhamento de performance de promoções',
      'Análise de ROI por campanha',
      'Alertas de promoções com baixo desempenho',
      'Relatórios de efetividade promocional'
    ]
  },
  {
    id: '3',
    title: 'Indicadores de Reputação',
    description: 'Monitore sua reputação no Mercado Livre com indicadores avançados. Acompanhe avaliações, tempo de resposta e satisfação dos clientes.',
    icon: 'Star',
    benefits: [
      'Monitoramento de avaliações em tempo real',
      'Análise de sentimento dos comentários',
      'Alertas de problemas de reputação',
      'Relatórios de satisfação do cliente'
    ]
  },
  {
    id: '4',
    title: 'Análise de Concorrência',
    description: 'Acompanhe seus concorrentes no Mercado Livre. Monitore preços, promoções e estratégias da concorrência para manter-se competitivo.',
    icon: 'Eye',
    benefits: [
      'Monitoramento de preços da concorrência',
      'Análise de estratégias promocionais',
      'Alertas de mudanças de preço',
      'Relatórios de posicionamento competitivo'
    ]
  },
  {
    id: '5',
    title: 'Gestão de Estoque',
    description: 'Controle seu estoque de forma inteligente. Receba alertas de produtos com baixo estoque e otimize sua gestão de inventário.',
    icon: 'Package',
    benefits: [
      'Alertas de estoque baixo',
      'Previsão de demanda',
      'Análise de sazonalidade',
      'Relatórios de turnover'
    ]
  },
  {
    id: '6',
    title: 'Performance de Vendas',
    description: 'Acompanhe suas vendas com métricas detalhadas. Analise tendências, sazonalidade e performance por categoria de produtos.',
    icon: 'DollarSign',
    benefits: [
      'Métricas de vendas em tempo real',
      'Análise de tendências de mercado',
      'Relatórios de performance por categoria',
      'Projeções de vendas futuras'
    ]
  }
];

export const testimonials: Testimonial[] = [
  {
    id: '1',
    name: 'Ana Silva',
    role: 'Diretora de TI',
    company: 'TechCorp',
    content: 'A BD Analytics revolucionou nossa tomada de decisões. Agora temos visibilidade completa dos nossos dados e conseguimos identificar oportunidades que antes passavam despercebidas.',
    avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face',
  },
  {
    id: '2',
    name: 'Carlos Santos',
    role: 'CEO',
    company: 'Inovação Labs',
    content: 'A implementação foi muito mais simples do que esperávamos. A equipe da BD Analytics entendeu perfeitamente nossas necessidades e entregou uma solução que superou nossas expectativas.',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face',
  },
  {
    id: '3',
    name: 'Maria Costa',
    role: 'Diretora de Marketing',
    company: 'Growth Agency',
    content: 'Os dashboards personalizados nos permitem acompanhar o ROI de todas as nossas campanhas em tempo real. Isso mudou completamente nossa estratégia de marketing.',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face',
  },
];

export const pricingPlans: PricingPlan[] = [
  {
    id: 'mensal',
    name: 'Mensal',
    price: 'R$ 189',
    description: 'Ideal para começar com a BD Analytics',
    features: [
      'Acesso completo à plataforma',
      'Todas as funcionalidades incluídas',
      'Suporte por email',
      'Atualizações automáticas',
      'Integração com Mercado Livre',
      'Dashboard personalizado',
    ],
  },
  {
    id: 'semestral',
    name: 'Semestral',
    price: 'R$ 894',
    description: 'Melhor custo-benefício para empresas em crescimento',
    features: [
      'Todas as funcionalidades do plano mensal',
      '6 meses de acesso completo',
      'Suporte prioritário',
      'Relatórios avançados',
      'Treinamento da equipe',
      'Parcelamento em até 6x',
    ],
    popular: true,
  },
  {
    id: 'anual',
    name: 'Anual',
    price: 'R$ 1.428',
    description: 'Máxima economia para empresas estabelecidas',
    features: [
      'Todas as funcionalidades dos outros planos',
      '12 meses de acesso completo',
      'Suporte 24/7',
      'Implementação dedicada',
      'Relatórios customizados',
      'Parcelamento em até 12x',
    ],
  },
];

export const footerLinks: FooterLink[] = [
  {
    title: 'Soluções',
    links: [
      { label: 'Business Intelligence', href: '#bi' },
      { label: 'Analytics', href: '#analytics' },
      { label: 'Mercado Livre', href: '#mercadolivre' },
      { label: 'Consultoria', href: '#consulting' },
    ],
  },
  {
    title: 'Empresa',
    links: [
      { label: 'Sobre', href: '#about' },
      { label: 'Blog', href: '#blog' },
      { label: 'Carreiras', href: '#careers' },
      { label: 'Imprensa', href: '#press' },
    ],
  },
  {
    title: 'Suporte',
    links: [
      { label: 'Central de Ajuda', href: '#help' },
      { label: 'Documentação', href: '#docs' },
      { label: 'Comunidade', href: '#community' },
      { label: 'Status', href: '#status' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacidade', href: '#privacy' },
      { label: 'Termos', href: '#terms' },
      { label: 'Cookies', href: '#cookies' },
      { label: 'Licenças', href: '#licenses' },
    ],
  },
];

// Estatísticas impressionantes da BD Analytics
export const stats = [
  {
    number: '900+',
    label: 'Usuários Ativos',
    description: 'Empresas que confiam na nossa plataforma'
  },
  {
    number: '5M+',
    label: 'Pedidos Processados',
    description: 'Dados analisados em tempo real'
  },
  {
    number: 'R$ 1B+',
    label: 'Valor Analisado',
    description: 'Transações monitoradas e otimizadas'
  }
];

// FAQ da BD Analytics
export const faqData = [
  {
    question: 'Por quantos dias consigo testar a BD Analytics?',
    answer: 'Oferecemos um período de teste gratuito de 14 dias com acesso completo a todas as funcionalidades. Durante este período, você pode explorar dashboards, criar relatórios e integrar suas fontes de dados para avaliar o valor da plataforma para sua empresa.'
  },
  {
    question: 'Preciso de conhecimento técnico para usar a plataforma?',
    answer: 'Não! Nossa plataforma foi desenvolvida para ser intuitiva e fácil de usar. Oferecemos treinamento gratuito para novos usuários e nossa equipe de suporte está sempre disponível para ajudar com implementações mais complexas.'
  },
  {
    question: 'Como funciona a consultoria especializada?',
    answer: 'A BD Consultoria é nossa unidade de negócio focada em aceleração de vendas em marketplaces como Mercado Livre, Shopee e Amazon. Este serviço pode ser contratado em conjunto com a BD Analytics para otimização completa das suas vendas online.'
  },
  {
    question: 'Posso cancelar minha assinatura a qualquer momento?',
    answer: 'Sim! Não há contratos de longo prazo. Para cancelar sua assinatura, entre em contato via email: financeiro@bdanalytics.com.br. Seus dados ficam disponíveis por 30 dias após o cancelamento para download.'
  }
]; 